module.exports = __webpack_public_path__ + "AbankSans-Regular-9c5f68a8da1cc1c709781dfa7e9f0908.woff";